import { doc } from "firebase/firestore";
import { useCallback, useMemo } from "react";
import { firestore } from "../../../config/firebase/app";
import { useAuth } from "../../auth/firebase-context";
import {
  InstantiatePortalNotificationFromJSON,
  NewsletterType,
  PortalNotification,
  PriorityType,
} from "../model/PortalNotification";
import useMakeSFRequest from "../../../request/salesforce/make-sf-call";

//NOTE: This hook encapsulates the behavior specific to the app implementing this lib.
interface PortalNotificationsResponse {
  status: number;
  portal_notifications: PortalNotification[];
}

export const portalNotificationsFirestoreKey = "Users";
export const usePortalNotificationsFetcher = () => {
  const { user } = useAuth();
  const request = useMakeSFRequest();
  const docRef = useMemo(() => {
    if (user === null) {
      return null;
    }
    return doc(firestore, portalNotificationsFirestoreKey, user.id);
  }, [user]);

  const handleRequest = useCallback(async () => {
    if (user === null) {
      return [];
    }

    const data = await request({
      endpointPath: "/api/portalNotification",
      method: "GET",
    })
      .then((response: any) => response)
      .catch((error: any) => {
        console.error("Failed to read notifications.", error);
        return [];
      });

    if (data.status !== 200) {
      throw new Error("Failed to read notifications.");
    }
    return data.portal_notifications;
  }, [user, request]);

  return useMemo(() => ({ docRef, handleRequest }), [docRef, handleRequest]);
};
